




















import { Component, Mixins, Watch } from "vue-property-decorator";
import { DialogMixin } from "../system/mixins";
import { DeveloperPresentableMixin } from "./mixins";
import DeveloperContents from "./DeveloperContents.vue";

@Component({
  components: {
    DeveloperContents,
  },
})
export default class DeveloperDialog extends Mixins(DialogMixin, DeveloperPresentableMixin) {
  async show(): Promise<void> {
    return this.showModal(async () => {
      await this.waitHidden();
    });
  }

  @Watch("isDeveloperMode")
  onDeveloperModeUpdated(newValue: boolean, oldValue: boolean): void {
    if (!newValue) {
      this.isVisible = false;
    }
  }
}
